import { useNavigate } from "react-router-dom";
import "./Landing.css";

export default function Landing(){
  const nav = useNavigate();

  return (
    <div className="landing-page">
      <div className="card landing-card">
        <h1>Welcome to LifeOS</h1>
        <p className="landing-subtitle">Manage your money. Track your life.</p>

        <div className="landing-actions">
          <button className="btn btn-primary" onClick={()=>nav("/login")}>Login</button>
          <button className="btn" onClick={()=>nav("/signup")}>Sign Up</button>
        </div>
      </div>
    </div>
  );
}
